export default "__VITE_ASSET__SA2rm4TZ__"